/** Inline Ory Network connect guidance (POST-ARC.12a). */

export const ORY_NETWORK_GUIDANCE = `To connect your Ory Network project:

1. Open the Ory Network Console and select your project.
2. Copy the project slug from the project URL or settings (the subdomain before .projects.oryapis.com).
3. Create a Project API key with admin access (ory_pat_ or ory_apikey_ prefix).
4. Paste the slug and API key below, then Test Connection before saving.

Deep reference: https://www.ory.com/docs/guides/console/projects/project-api-keys`;
